module.exports = __webpack_public_path__ + "static/media/tenlogo.02967075.svg";